var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "58C4B413-6641-4BE3-9FEE-25017306A083") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M113.375,498.6875 C113.375,504.037774 109.037774,508.375 103.6875,508.375 C98.3372266,508.375 94,504.037774 94,498.6875 C94,493.337227 98.3372266,489 103.6875,489 C109.037774,489 113.375,493.337227 113.375,498.6875 Z M102.566953,503.816953 L109.754453,496.629453 C109.998516,496.385391 109.998516,495.989648 109.754453,495.745586 L108.870586,494.861719 C108.626524,494.617617 108.230781,494.617617 107.98668,494.861719 L102.125,500.723359 L99.3883203,497.98668 C99.1442578,497.742617 98.7485156,497.742617 98.5044141,497.98668 L97.6205469,498.870547 C97.3764844,499.114609 97.3764844,499.510352 97.6205469,499.754414 L101.683047,503.816914 C101.927148,504.061016 102.322852,504.061016 102.566953,503.816953 L102.566953,503.816953 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI-KIt",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    transform: "translate(-94.000000, -489.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "check-circle",
    fill: "#7C809B",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default ForwardRef;